import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { toast } from "react-toastify";
import LeaveProcessService from "../services/LeaveProcessService";
import { useLoading } from "../Utils/LoadingContext";
import "./LeaveApply.css";

export default function AttendanceDetails() {

    const { setLoading } = useLoading();

    const [activeStartDate, setActiveStartDate] = useState(new Date());
    const [monthSummary, setMonthSummary] = useState([]);
    const [shiftTime, setShiftTime] = useState("");
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [reason, setReason] = useState("");
    const [startHour, setStartHour] = useState("08");
    const [startMinute, setStartMinute] = useState("00");
    const [endHour, setEndHour] = useState("18");
    const [endMinute, setEndMinute] = useState("00");
    const [comment, setComment] = useState("");

    const employeeCode = localStorage.getItem("empcode");
    const employeeName = localStorage.getItem("username");
    const today = new Date();

    // ================= LOAD DATA =================

    useEffect(() => {
        fetchMonthSummary(activeStartDate);
    }, [activeStartDate]);

    const getLeaveMMYY = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}${year}`;
    };

    const parseDate = (dateString) => {
        const parts = dateString.split(" ")[0].split("/");
        return new Date(parts[2], parts[0] - 1, parts[1]);
    };

    const formatDate = (date) => {
        return date.toLocaleDateString("en-GB");
    };

    const formatDateAPI = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    // ================= MONTH SUMMARY =================

    const fetchMonthSummary = async (date) => {

        try {

            setLoading(true);

            const formData = new FormData();
            formData.append("EmployeeCode", employeeCode);
            formData.append("Type", "GetMonthSummary");
            formData.append("LeaveMMYY", getLeaveMMYY(date));

            const response = await LeaveProcessService.getEmployeeCalender(formData);

            if (response.data.statusCode === 200) {
                setMonthSummary(response.data.result || []);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // ================= STATUS COLORS =================

    const getStatusColor = (date) => {

        const item = monthSummary.find(ms =>
            ms.punchDate &&
            parseDate(ms.punchDate).toDateString() === date.toDateString()
        );

        if (!item) return "";

        switch (item.status) {

            case "PP":
                return "status-pp";
            case "OD":
                return "status-pp";
            case "AR":
                return "status-pp";

            case "AP":
                return "status-ap";

            case "PA":
                return "status-pa";

            case "AA":
                return "status-aa";

            case "WO":
                return "status-wo";
            case "CL":
                return "leave-day";
            case "PL":
                return "leave-day";
            case "ACL":
                return "leave-day";
            case "CLA":
                return "leave-day";

            case "HO":
                return "status-hl";

            default:
                return "status-default";
        }
    };

    // ================= DATE CLICK =================

    const handleDateClick = (date) => {

        if (!fromDate) {
            setFromDate(date);
            setToDate(date);
        } else if (fromDate && toDate && fromDate.getTime() === toDate.getTime()) {

            if (date < fromDate) {
                setFromDate(date);
                setToDate(fromDate);
            } else {
                setToDate(date);
            }

        } else {
            setFromDate(date);
            setToDate(date);
        }
        debugger;
        // 🔥 FIND SELECTED DATE DATA
        const selected = monthSummary.find(ms =>
            ms.punchDate &&
            parseDate(ms.punchDate).toDateString() === date.toDateString()
        );

        if (selected) {
            setShiftTime(selected.shiftName || "09:00 - 18:00");
            setCheckIn(selected.firstPunchIn || "00:00");
            setCheckOut(selected.lastPunchOut || "00:00");

            // 🔥 AUTO FILL TIME INPUTS
            const inVal = selected.firstPunchIn;
            const outVal = selected.lastPunchOut;

            if (inVal && outVal && inVal.includes(":") && outVal.includes(":")) {

                const [inH, inM] = inVal.split(":");
                const [outH, outM] = outVal.split(":");

                setStartHour(inH);
                setStartMinute(inM);
                setEndHour(outH);
                setEndMinute(outM);

            } else {

                setStartHour("00");
                setStartMinute("00");
                setEndHour("00");
                setEndMinute("00");
            }
        }
        else {

            setShiftTime("");
            setCheckIn("--:--");
            setCheckOut("--:--");

            // ✅ RESET
            setStartHour("00");
            setStartMinute("00");
            setEndHour("00");
            setEndMinute("00");
        }
    };

    // ================= CALCULATE HOURS =================

    const calculateDuration = () => {

        const start = parseInt(startHour) * 60 + parseInt(startMinute);
        const end = parseInt(endHour) * 60 + parseInt(endMinute);

        const diff = end - start;

        if (diff <= 0) return "0";

        const hours = Math.floor(diff / 60);
        const minutes = diff % 60;

        return `${hours} hours ${minutes} minutes`;
    };

    // ================= VALIDATION =================

    const validateOnDuty = () => {

        if (!reason) {
            alert("Reason is required");
            return false;
        }

        if (!fromDate || !toDate) {
            alert("Select dates");
            return false;
        }

        if (!startHour || !startMinute || !endHour || !endMinute) {
            alert("Enter time properly");
            return false;
        }

        if (!comment.trim()) {
            alert("Comment required");
            return false;
        }

        return true;
    };

    // ================= SUBMIT =================
    const formatTime = (hour, minute) => {
        const h = String(hour).padStart(2, "0");
        const m = String(minute).padStart(2, "0");
        return `${h}:${m}`;
    };
    let numberOfDays = 0;

    if (fromDate && toDate) {
        const start = new Date(fromDate);
        const end = new Date(toDate);
        const diff = end - start;
        numberOfDays = Math.floor(diff / (1000 * 60 * 60 * 24)) + 1;
    }
    const handleOnDutySubmit = async () => {

        if (!validateOnDuty()) return;

        try {

            setLoading(true);

            const fromTime = formatTime(startHour, startMinute);
            const toTime = formatTime(endHour, endMinute);
            const formData = new FormData();
            debugger;
            formData.append("EmployeeCode", employeeCode);
            formData.append("FromDate", formatDateAPI(fromDate));
            formData.append("ToDate", formatDateAPI(toDate));
            formData.append("NoOfDays", numberOfDays);
            formData.append("LeaveUnit", "FULLDAY");
            formData.append("LeaveTypeID", 7);
            formData.append("StartTime", fromTime);
            formData.append("EndTime", toTime);
            formData.append("Reason", reason);
            formData.append("Comment", comment);
            formData.append("Type", "APPLY");
            formData.append("EmployeeName", employeeName);

            const response = await LeaveProcessService.setEmployeeLeave(formData);

            if (response.success && response.data.statusCode === 200) {

                alert("OnDuty applied successfully");

                setFromDate(null);
                setToDate(null);
                setReason("");
                setComment("");

            } else {
                const message = response.errorMessage || 'Submission failed. Please try again.';
                alert(message);
            }

        } catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            alert(message);
            console.error("Unhandled error:", message);
        } finally {
            setLoading(false);
        }
    };

    // ================= UI =================

    return (

        <div className="container py-3">

            <div className="row">

                {/* CALENDAR */}
                <div className="col-md-4">

                    <Calendar
                        onClickDay={handleDateClick}
                        activeStartDate={activeStartDate}
                        maxDate={today}
                        prev2Label="<<"
                        next2Label=">>"
                        onActiveStartDateChange={({ activeStartDate }) => {
                            setActiveStartDate(activeStartDate);
                        }}
                        tileClassName={({ date, view }) => {
                            if (view === "month") {
                                if (date > today) return "future-date";
                                return getStatusColor(date);
                            }
                        }}
                    />
                    {/* Legend */} <div className="mt-3 text-white" > <span className="small-text"> <span className="small-text" style={{ background: "#28a745", padding: "5px 5px", marginRight: 0 }}>PP - Present</span> </span> <span > <span className="small-text" style={{ background: "#dc3545", padding: "5px 5px", marginRight: 5 }}>AA - Absent</span> </span> <span> <span className="small-text" style={{ background: "#ff9800", padding: "5px 5px", marginRight: 5 }}>AP/PA - Half Day</span> </span> <span> <span className="small-text" style={{ background: "#a7bdc7", padding: "5px 5px", marginRight: 5 }}>WO</span> </span><span> <span className="small-text" style={{ background: "purple", padding: "5px 5px", marginRight: 5 }}>HO</span> </span><span> <span className="small-text" style={{ background: "blue", padding: "5px 5px", marginRight: 5 }}>L</span> </span> </div>

                </div>

                {/* RIGHT SIDE FORM */}
                <div className="col-md-8">


                    <div className="card p-3">

                        {fromDate ? (

                            <>
                                {/* TOP INFO ROW */}
                                <div className="row text-center ">

                                    <div className="col-md-4">
                                        <small className="text-muted">Shift</small>
                                        <div><strong>{shiftTime || "09:00 - 18:00"}</strong></div>
                                    </div>

                                    <div className="col-md-4">
                                        <small className="text-muted">Check in time</small>
                                        <div><strong>{checkIn || "--:--"}</strong></div>
                                    </div>

                                    <div className="col-md-4">
                                        <small className="text-muted">Check out time</small>
                                        <div><strong>{checkOut || "--:--"}</strong></div>
                                    </div>

                                </div>

                                <hr />
                                {/* REASON */}
                                <div className="mb-3">
                                    <label><span className="text-danger">*</span> Reason for request</label>
                                    <select
                                        className="form-select"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                    >
                                        <option value="">Select Reason</option>
                                        <option value="Site Visit">Site Visit</option>
                                        <option value="Plant Visit">Plant Visit</option>
                                        <option value="Client Visit">Client Visit</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                {/* DATES */}
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label>* From date</label>
                                        <input className="form-control" value={formatDate(fromDate)} readOnly />
                                    </div>
                                    <div className="col-md-6">
                                        <label>* To date</label>
                                        <input className="form-control" value={formatDate(toDate)} readOnly />
                                    </div>
                                </div>

                                {/* TIME */}
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label>* Start Hours</label>
                                        <input type="number" className="form-control" value={startHour} onChange={(e) => setStartHour(e.target.value)} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>* Start Minute</label>
                                        <input type="number" className="form-control" value={startMinute} onChange={(e) => setStartMinute(e.target.value)} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>* End Hours</label>
                                        <input type="number" className="form-control" value={endHour} onChange={(e) => setEndHour(e.target.value)} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>* End Minutes</label>
                                        <input type="number" className="form-control" value={endMinute} onChange={(e) => setEndMinute(e.target.value)} />
                                    </div>
                                </div>

                                {/* NOTE */}
                                <div className="alert alert-primary py-2">
                                    <strong>Note:</strong> You are marking OD for {calculateDuration()}
                                </div>

                                {/* COMMENT */}
                                <div className="mb-3">
                                    <label>* Comments</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                    />
                                </div>

                                {/* SUBMIT */}
                                <button className="btn btn-success" onClick={handleOnDutySubmit}>
                                    ADD
                                </button>

                            </>

                        ) : (
                            <h6>Select date(s) from calendar OnDuty Apply</h6>
                        )}

                    </div>

                </div>

            </div>

        </div>
    );
}